// Angular 
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { vwGroupPerformance } from '../dto/vwPerformance';
import { vwGroupPerformaceDetailed } from '../dto/vwPerformance';
import { of } from 'rxjs';


@Injectable({
  providedIn: 'root'
})

export class PerformanceService {

  constructor(public http: HttpClient) { }
  apiServer = environment.apiHost + environment.apiPort;

  LoadGroupPerformances(subscriber: string, hotelId: number, taskType: string) {

    // let res: vwGroupPerformance;
    // res = ({
    //   Groups: [
    //     {
    //       GroupName: "Group 1",
    //       Percent: 45,
    //       Members: [
    //         {
    //           PersonName: "Group 1 - John Doe 1",
    //           Percent: 10,
    //         },
    //         {
    //           PersonName: "Group 1 - John Doe 2",
    //           Percent: 20,
    //         },
    //         {
    //           PersonName: "Group 1 - John Doe 3",
    //           Percent: 30,
    //         },
    //         {
    //           PersonName: "Group 1 - John Doe 4",
    //           Percent: 40,
    //         },
    //         {
    //           PersonName: "Group 1 - John Doe 5",
    //           Percent: 50,
    //         },
    //         {
    //           PersonName: "Group 1 - John Doe 6",
    //           Percent: 60,
    //         },
    //         {
    //           PersonName: "Group 1 - John Doe 7",
    //           Percent: 70,
    //         },
    //         {
    //           PersonName: "Group 1 - John Doe 8",
    //           Percent: 80
    //         }
    //       ]

    //     },
    //     {
    //       GroupName: "Group 2",
    //       Percent : 45,
    //       Members: [
    //       {
    //         PersonName: "Group 2 - John Doe 1",
    //         Percent: 10,
    //       },
    //       {
    //         PersonName: "Group 2 - John Doe 2",
    //         Percent: 20, 
    //       },
    //       {
    //         PersonName: "Group 2 - John Doe 3",
    //         Percent: 30, 
    //       },
    //       {
    //         PersonName: "Group 2 - John Doe 4",
    //         Percent: 40, 
    //       },
    //       {
    //         PersonName: "Group 2 - John Doe 5",
    //         Percent: 50, 
    //       },
    //       {
    //         PersonName: "Group 2 - John Doe 6",
    //         Percent: 60, 
    //       },
    //       {
    //         PersonName: "Group 2 - John Doe 7",
    //         Percent: 70, 
    //       },
    //       {
    //         PersonName: "Group  - John Doe 8",
    //         Percent: 80 
    //       }
    //     ]

    //     },
    //     {
    //       GroupName: "Group 3",
    //       Percent : 45,
    //       Members: [
    //       {
    //         PersonName: "Group 3 - John Doe 1",
    //         Percent: 10,
    //       },
    //       {
    //         PersonName: "Group 3 - John Doe 2",
    //         Percent: 20, 
    //       },
    //       {
    //         PersonName: "Group 3 - John Doe 3",
    //         Percent: 30, 
    //       },
    //       {
    //         PersonName: "Group 3 - John Doe 4",
    //         Percent: 40, 
    //       },
    //       {
    //         PersonName: "Group 3 - John Doe 5",
    //         Percent: 50, 
    //       },
    //       {
    //         PersonName: "Group 3 - John Doe 6",
    //         Percent: 60, 
    //       },
    //       {
    //         PersonName: "Group 3 - John Doe 7",
    //         Percent: 70, 
    //       },
    //       {
    //         PersonName: "Group  - John Doe 8",
    //         Percent: 80 
    //       }
    //     ]

    //     }
    // ]
    // }
    // )

    // return of(res);
    return this.http.get(this.apiServer + '/api/kip/DailyTask/LoadGroupPerformances/' + subscriber + "/" + hotelId + "/" + taskType);

  }

  LoadGroupPerformancesDetailed(subscriber: string, hotelId: number, taskType: string, dateFrom: string, dateTo: string) {
     return this.http.get(this.apiServer + '/api/kip/DailyTask/LoadGroupPerformancesDetailed/' + subscriber + "/" + hotelId + "/" + taskType + "/" + dateFrom + "/" + dateTo); {
    }
  }
}
